export default {
    BENEFICIARYBOXRAISE_DRIVERBUTTON_DEFAULTS: {
        text: "Donation",
        urlLink: "/payments/donate/beneficiary/{{Id}}",
        show : true
    },

    BENEFICIARYBOXRAISE_SECONDARYBUTTON_DEFAULTS: {
        text: "Start Fundraising",
        urlLink: "/pages/create?cid={{Id}}",
        show : true
    },

    BENEFICIARYBOXRAISE_AMOUNT_DEFAULTS: {
        text: "Raised so far",
        show: true
    },

    DriverButtonBackgroundColour : "#f47d32",
    SecondaryButtonColour : "#1a3a49",
}